const SELECTED_BLUE_STROKE = "#256BDE";
const SELECTED_BLUE_FILL = "#256BDE";
const SELECTED_WHITE_FILL = "#ffffff";
const SELECTED_WHITE_STROKE = "#ffffff";

const INVALID_HOVER_FILL = "#d13050";
const INVALID_HOVER_STROKE = "#FF0000";

export const DESELECTED_GRAY = "#656565";

export const SELECTED_CHILD_STROKE_COLOR = "#4285F4";
export const DEFAULT_CLASS_CONTAINER_STYLE = {
    strokeStyle: DESELECTED_GRAY,
    radius: 5,
    lineWidth: 1
};

export const INVALID_CLASS_CONTAINER_STYLE = {
    strokeStyle: INVALID_HOVER_STROKE,
    fillStyle: INVALID_HOVER_FILL
};

export const SELECTED_CLASS_CONTAINER_STYLE = {
    strokeStyle: SELECTED_BLUE_STROKE,
    fillStyle: SELECTED_BLUE_FILL
};

export const SELECTED_CLASS_CONTAINER_TRIANGLE_STYLE = {
    strokeStyle: SELECTED_WHITE_STROKE,
    fillStyle: SELECTED_WHITE_FILL
};

export const CONTAINER_STYLE = {
    radius: {
        tl: 0, tr: 0, br: 8, bl: 8
    },
    lineWidth: 5
};

export const CONTAINER_MORE_ITEMS_INDICATOR = {
    fontSize: 12,
    textAlign: "left",
    textBaseline: "middle",
    paddingLeft: 10,
    selectedText: "#4285F4",
    deselectedText: "#000000"
};
